import React, { useCallback, useEffect, useState } from 'react'

import {
  Close,
  Icon,
  InfoFilled,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { PAYOUT_RATE_ARTICLE_URL } from '../Static/constants'

const STORAGE_KEY = 'payout_rates_updated_notice_closed'

const hasBeenClosed = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'true'
  } catch (_) {
    return false
  }
}

const markClosed = () => {
  try {
    window.localStorage.setItem(STORAGE_KEY, 'true')
  } catch (_) {
    // Storage may be unavailable (private mode, quota). Treat as no-op.
  }
}

function PayoutRatesUpdatedNotice() {
  // Seeded false so the SSR markup and the first client render agree; the stored
  // dismissal is applied after mount to avoid a hydration mismatch.
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    if (hasBeenClosed()) {
      setDismissed(true)
    }
  }, [])

  const handleDismiss = useCallback(() => {
    markClosed()
    setDismissed(true)
  }, [])

  if (dismissed) {
    return null
  }

  return (
    <div className="payout-rates-updated-notice" role="status">
      <Icon svgComponent={InfoFilled} color="dark" notSpaced />
      <p className="payout-rates-updated-notice__message cgt-body-base cgt-mb-0">
        Payout rates updated on September 15, 2026.{' '}
        <a
          className="payout-rates-updated-notice__link cgt-link-primary"
          href={PAYOUT_RATE_ARTICLE_URL}
          target="_blank"
          rel="noreferrer"
        >
          Learn more
        </a>
      </p>
      <button
        type="button"
        className="payout-rates-updated-notice__dismiss"
        aria-label="Dismiss"
        onClick={handleDismiss}
      >
        <Icon svgComponent={Close} color="dark" notSpaced size="small" />
      </button>
    </div>
  )
}

export default PayoutRatesUpdatedNotice
